import axios from 'axios'
import React, { useState } from 'react'
import authService from '../../../Components/Login/auth.service'

export default function Modal({ setOpenModal, modalInfo }) {
  var user = authService.getCurrentUser()
  const [modal, setModal] = useState(false)

  const toggleModal = () => {
    setModal(!modal)
  }

  if (modal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }
  let newDate = new Date()

  const [campos, setCampos] = useState({
    IdTipoDocumento: modalInfo.IdTipoDocumento,
    IdEmpresa: modalInfo.IdEmpresa,
    tpdDescricao: modalInfo.tpdDescricao,
    tpdStatus: modalInfo.tpdStatus,
    tpdObservacoes: modalInfo.tpdObservacoes,
    tpdAlteradoPor: user[0].pesEmail,
    tpdAlteradoEm: newDate
  })
  function handleInputChange(event) {
    if (event.target.name === 'tpdStatus') {
      if (event.target.checked) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else {
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)
  }
  function handleFormSubmit(event) {
    event.preventDefault()
    axios
      .put(
        process.env.REACT_APP_API_URL +
        '/api/v1/tipodocumento/' +
        campos.IdTipoDocumento,
        campos
      )
      .then(response => {
        alert(response.data.message)
        window.location.reload()
      })
  }
  return (
    <div className="modalArea">
      <div onClick={toggleModal} className="overlay"></div>
      <div className="modalPadrao-content">
        <div className="cxTituloPadrao">
          <h1>
            Editar Tipo de Documento
            <hr className="hrTitleModal" />
          </h1>
          <button
            onClick={() => {
              setOpenModal(false)
            }}
          >
            X
          </button>
        </div>
        <form onSubmit={handleFormSubmit}>
          <label>Descrição:</label>
          <input
            placeholder="Descrição"
            type="text"
            id="fname"
            defaultValue={campos.tpdDescricao}
            name="tpdDescricao"
            onChange={handleInputChange}
          ></input>

          <label>Observação:</label>
          <textarea
            placeholder="Observações"
            type="text"
            id="fname"
            name="tpdObservacoes"
            defaultValue={campos.tpdObservacoes}
            row="none"
            onChange={handleInputChange}
            maxLength="500"
          ></textarea>

          <div className="caixaSalvarPadrao">
            <div className="InputAuthorization4">
              <label>
                <input
                  name="tpdStatus"
                  type="checkbox"
                  defaultChecked={!!campos.tpdStatus}
                  onChange={handleInputChange}
                />
                <span className="checkTextArea">Status</span>
              </label>
            </div>
            <button type="submit">Salvar Registro</button>
          </div>
        </form>
      </div>
    </div>
  )
}
